import React from 'react';
import { DialogNative } from './components/native.js';
import { DialogCustom } from './components/custom.js';
export const Dialog = (props) => {
    if (props.type === 'custom') {
        return React.createElement(DialogCustom, { ...props });
    }
    return React.createElement(DialogNative, { ...props });
};
Dialog.displayName = 'Dialog';
//# sourceMappingURL=index.js.map